export default __webpack_public_path__ + "static/media/1_roadmap.1179e0c6.png";